const b64toBlob = (b64Data, contentType = '', sliceSize = 512) => {
  const byteCharacters = atob(b64Data);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);

    byteArrays.push(byteArray);
  }

  return new Blob(byteArrays, { type: contentType });
};

const contentType = 'video/mp4';
const b64Data =
  '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';

const blob = b64toBlob(b64Data, contentType);
const blobUrl = window.URL.createObjectURL(blob);

export const checkBrowserAutoplay = () =>
  new Promise((resolve) => {
    const video = document.createElement('video');
    video.width = 1;
    video.height = 1;
    video.playsInline = true;
    document.body.appendChild(video);
    video.src = blobUrl;
    const playPromise = video.play();
    if (playPromise) {
      playPromise
        .then(() => {
          resolveVideoPromise(video, BROWSER_AUTOPLAY_ABILITY.ALWAYS);
        })
        .catch(() => {
          video.muted = true;
          video
            .play()
            .then(() => {
              resolveVideoPromise(video, BROWSER_AUTOPLAY_ABILITY.WHEN_MUTED);
            })
            .catch(() => {
              resolveVideoPromise(video, BROWSER_AUTOPLAY_ABILITY.NEVER);
            });
        });
    } else {
      resolveVideoPromise(video, BROWSER_AUTOPLAY_ABILITY.ALWAYS);
    }

    function disposeVideo(pVideo) {
      if (pVideo && pVideo.parentNode) {
        pVideo.pause();
        pVideo.parentNode.removeChild(pVideo);
      }
    }

    function resolveVideoPromise(pVideo, value) {
      disposeVideo(pVideo);
      resolve(value);
    }
  });

export const checkStreamAutoplay = (
  browserAutoplay,
  configAutoplay,
  streamAutoplay
) => {
  let autoplay;
  if (!browserAutoplay) {
    autoplay = false;
  } else {
    autoplay = configAutoplay;
    if (autoplay !== false) {
      autoplay = streamAutoplay;
    }
  }
  return autoplay;
};

export const BROWSER_AUTOPLAY_ABILITY = {
  ALWAYS: 'always',
  WHEN_MUTED: 'whenMuted',
  NEVER: 'never',
};
